import { Component, ElementRef, Inject, OnInit } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { DomSanitizer } from '@angular/platform-browser';
import { TylerMatTableDataSource } from '../../../../../shared-components/angular-material/extended.class';
import { ErrorList } from '../../../../../shared-components/controls/error-prompt/error-list.model';
import { YearService } from '../../../../../shared-components/year/year.service';
import { ReportV9 } from '../../../models/report-v9.model';
import { V9ParameterRow, V9ParameterRows } from '../../../models/v9-parameter-row.model';
import { V9ReportParameter } from '../../../models/v9-report-parameter.model';
import { ReportingService } from '../../../reporting.service';

@Component({
  selector: 'app-v9-letter-report-parameters',
  templateUrl: './v9-letter-report-parameters.component.html',
  styles: []
})
export class V9LetterReportParametersComponent implements OnInit {

  reportParameters: V9ReportParameter[] = [];
  chunkedParameters: V9ParameterRows;
  errors: ErrorList[] = [];
  selectedReport: ReportV9;
  gridDataMatDataSource: TylerMatTableDataSource;
  columnToDisplay: string[];
  selectAllGridRecords = false;

  constructor(
    private reportingService: ReportingService,
    private dialogRef: MatDialogRef<V9LetterReportParametersComponent>,
    private dialog: MatDialog,
    private yearService: YearService,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private sanitizer: DomSanitizer
  ) { }

  ngOnInit() {
    if (this.data != undefined) {
      this.selectedReport = this.data.selectedReport;
      this.reportParameters = this.data.reportParameters;
      this.setParameterRows();
    }
  }

  getParameterStyle(parameter: V9ReportParameter): object {
    let obj: object = null;
    if (parameter != null && parameter.ParameterStyle != '') {
      obj = JSON.parse('{' + parameter.ParameterStyle + '}');
    }

    return obj;
  }

  setParameterRows() {
    this.chunkedParameters = new V9ParameterRows();
    const reportParameter = this.reportParameters[this.reportParameters.length - 1];
    if (reportParameter != null) {
      for (let rowIndex = 0; rowIndex < reportParameter.RowNumberInTable; rowIndex++) {
        const parameterRow = new V9ParameterRow();
        let includeLineAtStartOfGroup = true;
        let includeLineAtEndOfGroup = true;
        this.reportParameters.filter(o => o.RowNumberInTable == rowIndex + 1 && o.IsLetterParameter == true).forEach(obj => {
          obj.Disabled = false;
          if (obj.DataType == 'BIT') {
            if (typeof (obj.Value) != 'boolean') {
              obj.Value = obj.Value != null && obj.Value.toUpperCase() == 'TRUE' ? true : false;
            }
          }
          if (obj.IncludeLineAtStartOfGroup != includeLineAtStartOfGroup) {
            includeLineAtStartOfGroup = false;
          }
          if (obj.IncludeLineAtEndOfGroup != includeLineAtEndOfGroup) {
            includeLineAtEndOfGroup = false;
          }
          if (obj.ParentId != null && obj.ParentId > 0) {
            const parentReportParameter = this.reportParameters.filter(o => o.Id == obj.ParentId)[0];
            if (parentReportParameter.ControlType == 'rbl') {
              const parentValue = obj.ParentValue.split(',');
              if (parentValue.length > 1) {
                if (parentValue.indexOf(parentReportParameter.Value) > -1) {
                  obj.Disabled = false;
                }
                else {
                  obj.Disabled = true;
                }
                obj.Disabled = obj.Disabled == false && parentReportParameter.Disabled == true ? true : obj.Disabled;
              }
              else {
                obj.Disabled = parentReportParameter.Disabled == true ? true : obj.ParentValue.toUpperCase() != parentReportParameter.Value.toString().toUpperCase() && obj.ParentValue != '';
              }

              const parameterParentValue = this.reportParameters.filter(x => x.Id == obj.ParentId)[0];
              if (parameterParentValue != undefined && parameterParentValue != null && parameterParentValue.Value == 'Journal') {
                this.reportParameters.filter(x => x.IsLetterParameter == true && x.ParameterName != 'blnPrimaryParentsAddress' && x.ParameterName != 'blnAlternateParentsAddress'
                  && x.ParameterName != 'blnAlternateParAddrOnlyIfRequested' && x.ParameterName !='blnStudentAddress' && x.ParameterName != 'strReportType' && x.ParameterName != 'bytMailingLanguage').forEach(o => {
                    o.Disabled = true;
                    if (o.ParameterName == 'blnIncludePdfAttachment') {
                      o.Value = null;
                    }
                    if (o.ParameterName == 'strEmailOptions') {
                      o.Value = 'SendEmail';
                    }
                  });
              }
            }
            else {
              if (parentReportParameter != null && parentReportParameter.Value != null) {
                if (obj.DataSource == null && obj.ControlType == 'ddl') {
                  // parentReportParameter.Disabled = true;
                }
                if (parentReportParameter.Disabled == true) {
                  obj.Disabled = true;
                }
                else {
                  if (obj.ParentValue.toUpperCase() != '') {
                    if (obj.ParentValue.toUpperCase() != parentReportParameter.Value.toString().toUpperCase()) {
                      obj.Disabled = true;
                    }
                  }
                }
                // obj.Disabled = parentReportParameter.Disabled == true ? true : obj.ParentValue.toUpperCase() != parentReportParameter.Value.toString().toUpperCase();
              }
            }
          }

          if (obj.ControlType == 'cbl') {
            if (obj.DataSource != null) {
              if (obj.DataSource.length > 0) {
                const variable = obj.Value.split(',');
                variable.forEach(ele => {
                  obj.DataSource.forEach(element => {
                    if (element.ValueField == ele) {
                      element.IsSelected = true;
                    }
                  });
                });
              }
            }
          }

          if (obj.ControlType == 'ddcbl') {
            if (obj.Value != '' && obj.Value != null) {
              const objValue: string[] = [];
              const variable = obj.Value.split(',');
              variable.forEach(element => {
                objValue.push(element);
              });
              if (objValue.length > 0) {
                obj.Value = objValue;
              }
            }
          }

          if (obj.ControlType == 'img') {
            if (obj.Value != '' && obj.Value != null) {
              if (obj.Value['changingThisBreaksApplicationSecurity'] == undefined && obj.Value['changingThisBreaksApplicationSecurity'] == null) {
                obj.Value = this.sanitizer.bypassSecurityTrustResourceUrl('data:image/png;base64, ' + obj.Value);
              }
            }
          }

          if (obj.ControlType == 'ddl') {
            if (obj.Value != '') {
              if (obj.DataSource != null) {
                const objDataSourceValue = obj.DataSource.filter(x => x.ValueField == obj.Value);
                if (objDataSourceValue.length == 0) {
                  if (obj.DataSource != null && obj.DataSource.length > 0) {
                    obj.Value = obj.DataSource[0].ValueField;
                  }
                }
              }
              else if (obj.DataSource == null) {
                obj.Value = '';
              }
            }
          }

          parameterRow.Parameters.push(obj);
        });
        parameterRow.IncludeLineAtStartOfGroup = includeLineAtStartOfGroup;
        parameterRow.IncludeLineAtEndOfGroup = includeLineAtEndOfGroup;
        this.chunkedParameters.Rows.push(parameterRow);
      }
    }

  }

  parameterChanged(parameter: V9ReportParameter) {
    if (parameter.ControlType == 'chk') {
      this.reportParameters.filter(o => o.ParentId == parameter.Id).forEach(obj => {
        obj.Disabled = false;
        if (obj.ParentValue != null && parameter.Value != null) {
          if (obj.ParentValue.toUpperCase() != parameter.Value.toString().toUpperCase()) {
            obj.Disabled = true;
          }
        }
        this.reportParameters.filter(x => x.ParentId == obj.Id).forEach(element => {
          element.Disabled = obj.Disabled;
        });
      });
    }
    if (parameter.ControlType == 'rbl') {
      this.reportParameters.filter(o => o.ParentId == parameter.Id).forEach(obj => {
        obj.Disabled = false;
        const parentValue = obj.ParentValue.split(',');
        if (parentValue.length > 1) {
          if (parentValue.indexOf(parameter.Value) > -1 && obj.IsRequired == false) {
            obj.Disabled = false;
          }
          else {
            obj.Disabled = true;
            if (obj.ControlType == 'chk') {
              obj.Value = null;
            }
          }
        }
        else {
          if (obj.ParentValue != null && parameter.Value != null) {
            if (obj.ParentValue != parameter.Value && obj.ParentValue != '') {
              obj.Disabled = true;
              obj.Value = null;
            }
          }
          this.reportParameters.filter(x => x.ParentId == obj.Id).forEach(element => {
            if (obj.Value != null && element.ParentValue.toUpperCase() != obj.Value.toString().toUpperCase()) {
              element.Disabled = true;
            }
            else {
              if (obj.Value == null) {
                element.Disabled = true;
              }
              else {
                element.Disabled = obj.Disabled;
              }
            }
          });
        }
      });
      if (parameter.Value == 'Journal') {
        this.reportParameters.filter(x => x.IsLetterParameter == true && x.ParameterName != 'blnPrimaryParentsAddress' && x.ParameterName != 'blnAlternateParentsAddress'
          && x.ParameterName != 'blnAlternateParAddrOnlyIfRequested' && x.ParameterName !='blnStudentAddress' && x.ParameterName != 'strReportType' && x.ParameterName != 'bytMailingLanguage').forEach(obj => {
            obj.Disabled = true;
            if (obj.ParameterName == 'blnIncludePdfAttachment') {
              obj.Value = null;
            }
            if (obj.ParameterName == 'strEmailOptions') {
              obj.Value = 'SendEmail';
            }
          });
      }
      else if (parameter.Value == 'Report' || parameter.Value == 'Letters') {
        this.reportParameters.filter(o => o.ParentId == parameter.Id && o.ControlType == 'rbl').forEach(obj => {
          this.reportParameters.filter(o => o.ParentId == obj.Id).forEach(ele => {
            ele.Disabled = false;
            const parentValues = ele.ParentValue.split(',');
            if (parentValues.length > 1) {
              if (parentValues.indexOf(obj.Value) > -1 && ele.IsRequired == false) {
                ele.Disabled = false;
              }
              else {
                ele.Disabled = true;
              }
            }
            else {
              if (ele.ParentValue != null && obj.Value != null) {
                if (ele.ParentValue != obj.Value && ele.ParentValue != '') {
                  ele.Disabled = true;
                }
              }
              this.reportParameters.filter(x => x.ParentId == ele.Id).forEach(element => {
                element.Disabled = ele.Disabled;
              });
            }
          });
        });
        this.reportParameters.forEach(obj => {
          if (obj.ParameterName == 'blnUsingSchoolLetterHead') {
            obj.Disabled = false;
          }
          if (obj.ParameterName == 'bytPrintLogo') {
            obj.Disabled = false;
          }
          if (obj.ParameterName == 'blnPrintToMailFormat') {
            obj.Disabled = false;
          }
          if (obj.ParameterName == 'blnPrintSchoolAddress') {
            obj.Disabled = false;
          }
          if (obj.ParameterName == 'blnReverseName') {
            obj.Disabled = false;
          }
          if (obj.ParameterName == 'blnPrintFullDuplex') {
            obj.Disabled = false;
          }
          if (obj.ParameterName == 'blnPrintTeacherName') {
            obj.Disabled = false;
          }
        });
      }
      const parameterParentValue = this.reportParameters.filter(x => x.Id == parameter.ParentId)[0];
      if (parameterParentValue != undefined && parameterParentValue != null && parameterParentValue.Value == 'Journal') {
        this.reportParameters.filter(x => x.IsLetterParameter == true && x.ParameterName != 'blnPrimaryParentsAddress' && x.ParameterName != 'blnAlternateParentsAddress'
          && x.ParameterName != 'blnAlternateParAddrOnlyIfRequested' && x.ParameterName !='blnStudentAddress' && x.ParameterName != 'strReportType' && x.ParameterName != 'bytMailingLanguage').forEach(obj => {
            obj.Disabled = true;
            if (obj.ParameterName == 'blnIncludePdfAttachment') {
              obj.Value = null;
            }
            if (obj.ParameterName == 'strEmailOptions') {
              obj.Value = 'SendEmail';
            }
          });
      }

    }
  }

  validationFields() {
    this.errors = [];
    this.selectedReport.ReportParameters = this.reportParameters.filter(o => o.IsLetterParameter == true && o.ParentId != 0 && o.IsRequired == false);
    this.selectedReport.ReportParameters.forEach(obj => {
      const parentobject = this.reportParameters.filter(o => o.Id == obj.ParentId)[0];
      if (parentobject) {
        if (this.selectedReport.ReportParameters.filter(x => x.Id == parentobject.Id).length == 0) {
          this.selectedReport.ReportParameters.push(parentobject);
        }
      }
    });
    this.reportingService.getV9ReportParameterValidation(this.selectedReport).subscribe(result => {
      if (result != '') {
        const errormessage = result.split('|');
        errormessage.forEach(obj => {
          if (obj != '' && obj != 'Subject is required' && obj !='Message is required') {
            this.errors.push({
              fieldName: '',
              fieldRef: null,
              errorMsg: obj
            });
          }
          else if (obj != '' && obj == 'Subject is required'){
              const parentobject = this.selectedReport.ReportParameters.filter(o => o.ColumnName == 'strEmailSubject')[0];
              if (parentobject) {
                const strFieldId ='txt' + parentobject.ParameterName + '_' + parentobject.Id;
                const htmlElement: Element = document.getElementById(strFieldId);
                const control = new ElementRef(htmlElement);
                  this.errors.push({
                    fieldName: 'Subject',
                    fieldRef: control,
                    errorMsg: obj
                  });
              }
          }
              else if (obj =='Message is required'){
              const parentobject = this.selectedReport.ReportParameters.filter(o => o.ColumnName == 'strEmailBody')[0];
              if (parentobject) {
                const strFieldId ='rtxt' + parentobject.ParameterName + '_' + parentobject.Id;
                const htmlElement: Element = document.getElementById(strFieldId);
                const control = new ElementRef(htmlElement);
                  this.errors.push({
                    fieldName: 'Message',
                    fieldRef: control,
                    errorMsg: obj
                  });
              }
            }
        });
      }
      this.validateRequiredFields();
      this.okClick();
    });
  }

  validateRequiredFields() {
    this.reportParameters.filter(o => o.IsVisible == true && o.Disabled == false && o.IsRequired == true).forEach(obj => {
      if (obj.Value == null || obj.Value.toString() == '') {
        let fieldName: string;
        if (obj.Name != null && obj.Name != '') {
          fieldName = obj.Name;
        }
        else if (obj.ParentId != null && obj.ParentId > 0) {
          const parentObject = this.reportParameters.filter(o => o.Id == obj.ParentId)[0];
          if (parentObject != null && parentObject.Name != null && parentObject.Name != '') {
            fieldName = parentObject.Name;
          }
        }
        fieldName = fieldName.replace(':', '');

        this.errors.push({
          fieldName: fieldName,
          fieldRef: null,
          errorMsg: 'Field is required'
        });
      }
    });
  }

  selectAllGridRecordsChange() {
  }

  closeClick() {
    this.dialogRef.close(null);
  }

  okClick() {
    if (this.errors.length == 0) {
      this.dialogRef.close(this.reportParameters);
    }
  }

}
